<template>
  <div>
    <div class="videoBox">
      <div class="videoTitle" @click="dialogVisiblmonitor = true"></div>
      <div class="sliderBox" @click.stop="clickProps($event)">
        <vue-seamless-scroll
          :data="newsList"
          :class-option="Option"
          class="seamless-warp2"
        >
          <ul class="item">
            <li v-for="(item, index) in newsList" :key="index">
              <img
                :src="item.url"
                class="videoImg"
                :data-obj="JSON.stringify(item)"
              />
            </li>
          </ul>
        </vue-seamless-scroll>
      </div>
    </div>
    <!-- 监控轮播 弹框 -->
    <div>
      <el-dialog
        :visible.sync="dialogVisiblmonitor"
        width="54%"
        :modal="moadl"
        :close-on-click-modal="false"
        :show-close="false"
        :destroy-on-close="true"
        center
      >
        <span slot="title">
          <img :src="detail_icon_Monitor" alt="" class="dialog-title" />
        </span>
        <img
          :src="detail_icon_one"
          alt=""
          class="close-icon"
          @click="close()"
          style="cursor: pointer"
        />
        <div>
          <slidervideo v-if="dialogVisiblmonitor" :videoId="videoId"></slidervideo>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import slidervideo from "./detail_video/surveillanceList.vue";
export default {
  components: {
    slidervideo,
  },
  data() {
    return {
      newsList: [],
      imgList: [
        require("../../assets/testimages/1.png"),
        require("../../assets/testimages/2.png"),
        require("../../assets/testimages/3.png"),
        require("../../assets/testimages/4.png"),
        require("../../assets/testimages/5.png"),
        require("../../assets/testimages/6.png"),
      ],
      moadl: false,
      dialogVisiblmonitor: false,
      detail_icon_Monitor: require("@/assets/images/surveillanceVideo.png"),
      detail_icon_one: require("@/assets/images/路径 28736_2@2x.png"),
      videoId:'',
    };
  },
  computed: {
    Option() {
      return {
        step: 1, // 数值越大速度滚动越快
        limitMoveNum: 3, // 开始无缝滚动的数据量
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 3, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  mounted() {
    this.getSafeVillagePageList();
  },
  methods: {
    clickProps(e) {    
      let b = JSON.parse(e.target.dataset.obj);
      this.videoId = b.id;
      this.dialogVisiblmonitor = true;
    },
    getSafeVillagePageList() {
      var video = plOtherDataInterface.getSafeVillagePage(1, 6);
      let resData = video.list;
      resData.forEach((val, index) => {
        this.$set(val, "url", this.imgList[index]);
      });
      this.newsList = resData;
    },
    close(){
      this.videoId='';
      this.dialogVisiblmonitor = false;
    }
  },
};
</script>
<style lang="less" scoped>
.videoBox {
  display: flex;
  flex-wrap: nowrap;
}
.videoTitle {
  width: 65px;
  height: 85px;
  background: url("../../assets/video/videoIcon.png");
}
.sliderBox {
  overflow: hidden;
  height: 75px;
  width: 100%;
}
.seamless-warp2 {
  overflow: hidden;
  height: 75px;
  width: 100%;
}
.item {
  width: 100%;
}
ul li {
  float: left;
  margin-right: 10px;
}
.videoImg {
  width: 92px;
  height: 75px;
  margin-top: 7px;
  background: rgba(0, 0, 0, 0);
}

.div {
  width: 33%;
}
/deep/ .el-dialog {
  background: #15606e;
  border: 1px solid #2bf9fc;
  margin-top: 17vh !important;
}
/deep/.el-dialog--center .el-dialog__body {
  padding: 0px 18px 20px;
}
/deep/.el-dialog__header {
  padding: 26px 20px 10px;
}
.close-icon {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 32px;
  right: 41px;
  cursor: pointer;
}
.dialog-title {
  width: 156px;
  height: 40px;
}
</style>





// WEBPACK FOOTER //
// src/components/rightAside/rightAsideVideo.vue